import React, { useRef } from 'react';
import { Box, Container } from '@hover/blueprint';
import styled from '@emotion/styled';
import Slider from 'react-slick';
import { SlickSliderContainer } from '../../ui';
import { HOME_PAGE_CASE_STUDIES } from '../../../constants';
import CaseStudy from './CaseStudy';

const StyledSlider = styled(SlickSliderContainer)`
  .slick-dots {
    bottom: 70px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    left: 0;
    right: 0;
  }

  .slick-dots li {
    width: 20px;
  }

  .slick-dots li button:before {
    font-size: 12px;
    opacity: 1;
    color: #333333;
  }

  .slick-dots li.slick-active button:before {
    color: #2277d1;
  }

  @media (max-width: 834px) {
    .slick-dots {
      bottom: 35px;
    }
  }
`;

const settings = {
  dots: true,
  infinite: true,
  speed: 1500,
  autoplaySpeed: 10000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  useTransform: false,
};

const HomePageCaseStudies: React.FC = () => {
  const sliderRef = useRef<Slider>(null);

  return (
    <Box
      w="100%"
      bg={{ base: 'neutral.0', tablet: 'brandNavy.100' }}
      px={{ base: 500, tablet: 0 }}
    >
      <Container
        bg="brandNavy.100"
        maxW="1200px"
        px={{ base: 400, tablet: '56px', desktop: 500 }}
        borderRadius={{ base: '8px', tablet: 0 }}
        shadow={{ base: 'distance300', tablet: 'none' }}
      >
        <StyledSlider ref={sliderRef} {...settings}>
          {HOME_PAGE_CASE_STUDIES.map(caseStudy => (
            <CaseStudy caseStudy={caseStudy} key={caseStudy.id} />
          ))}
        </StyledSlider>
      </Container>
    </Box>
  );
};

export default HomePageCaseStudies;
